import dynamic from 'next/dynamic';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Skeleton from 'react-loading-skeleton';

import useWindowSize from '#app/hooks/useWindowSize';

import { toPX } from '../../../helpers/toPX';
import { typo_16 } from '../../atoms/typography/typography.module.scss';
import styles from './index.module.scss';

const Typography = dynamic(() => import('../../atoms/typography/typography'));

const MiniCourse = ({
 image, text, color = 'black', check, marginBottom = [0, 0] 
}) => {
  const { isDesktop } = useWindowSize();

  return (
    <div
      className={styles.container}
      style={{ marginBottom: toPX(isDesktop, marginBottom) }}
    >
      {/* Image */}
      <div className={styles.image}>
        <LazyLoadImage
          effect="blur"
          alt="preview"
          width="36px"
          height="40px"
          src={image}
          placeholder={<Skeleton width="100%" height="100%" />}
        />
      </div>

      {/* Text */}
      <div className={styles.text}>
        <Typography variant={typo_16} fontWeight={400} color={color} tag="p">
          {text}
        </Typography>

        {/* Check */}
        {check && (
          <div className={styles.check}>
            <svg
              width="18"
              height="14"
              viewBox="0 0 18 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.00016 10.9872L1.83016 6.81723L0.410156 8.22723L6.00016 13.8172L18.0002 1.81723L16.5902 0.407227L6.00016 10.9872Z"
                fill="#583AF0"
              />
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default MiniCourse;
